import { render, staticRenderFns } from "./FormActions.vue?vue&type=template&id=06249bba&scoped=true"
import script from "./FormActions.vue?vue&type=script&lang=js"
export * from "./FormActions.vue?vue&type=script&lang=js"
import style0 from "./FormActions.vue?vue&type=style&index=0&id=06249bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06249bba",
  null
  
)

export default component.exports